/****************************************************************************************************
 * Load Global Config
 */
require('./_global.js');

/*****************************************************************************************************
 * Load Window Global
 */
// below in _global.js
// window.Vue.use(require('vue-cookies'));
// window.MobileDetect = require('mobile-detect');

/*****************************************************************************************************
 * Lodd Popper
 */
window.Popper = require('popper.js').default;

/*****************************************************************************************************
 * Load Global Vue Config
// below in _global.js
// require('./_vue_config.js');

/*****************************************************************************************************
 * Load Filter
 */
import Filters from '@RESOURCES/js/filters';

window.Vue.use(Filters);

/*****************************************************************************************************
 * Load Lodash
 */
// below in _global.js
// window._ = require('lodash');

/*****************************************************************************************************
 * Load Bootstrap Modules - Avoid loading the entire bootstrap
 */
require('bootstrap/js/src/collapse.js');

/*****************************************************************************************************
 * Load Libraries
 */

require('@RESOURCES/js/core');
require('@RESOURCES/js/globalnav');

/*****************************************************************************************************
 * Load All Internal Components
 */
// included in the module JS file
